import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import Layout from "Layout";
import NonAuthLayout from "Layout/NonLayout";
import AuthProtected from "./AuthProtected";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ToastContainer } from "react-toastify";

const queryClient = new QueryClient();

const RouteIndex = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <React.Fragment>
        <Routes>
          {authProtectedRoutes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthProtected>
                  <Layout>
                    <Suspense fallback={<div>Loading...</div>}>
                      <route.component />
                    </Suspense>
                  </Layout>
                </AuthProtected>
              }
            />
          ))}
          {publicRoutes.map((route: any, idx: number) => (
            <Route
              path={route.path}
              key={idx}
              element={
                <NonAuthLayout>
                  <Suspense fallback={<div>Loading...</div>}>
                    <route.component />
                  </Suspense>
                </NonAuthLayout>
              }
            />
          ))}
        </Routes>
        <ToastContainer />
      </React.Fragment>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default RouteIndex;
